import { MediaViewerPage } from '@jarvis/platform-ui';

export function ImageViewerPage() {
  return <MediaViewerPage kind="image" filesLinkTo="/files" filesLinkLabel="Files" />;
}
